<template>
  <div>
    <el-page-header class="detail-head" @back="goBack">
      <template v-slot:content>
        <div class="toolbar">
          <span>用户详情</span>
          <div class="toolbar-items">
            <el-button size="mini" type="success" @click="openLargeDiscount">设置大客户折扣</el-button>
          </div>
        </div>
      </template>
    </el-page-header>

    <el-divider></el-divider>
    <div class="detail-container">
      <el-scrollbar>
        <el-form class="detail-form" ref="mainForm" :model="entity" :rules="rules" label-width="100px">
          <el-row :gutter="20">
            <el-col :span="6">
              <div class="grid-content">
                <el-form-item label="用户名" class="detail-form-item" prop="name">
                  <el-input size="medium" v-model="entity.name" readonly></el-input>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content">
                <el-form-item label="用户昵称" class="detail-form-item">
                  <el-input size="medium" v-model="entity.realName"></el-input>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content">
                <el-form-item label="手机号" class="detail-form-item">
                  <el-input size="medium" v-model="entity.phone"></el-input>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content">
                <el-form-item label="邮箱" class="detail-form-item">
                  <el-input size="medium" v-model="entity.email"></el-input>
                </el-form-item>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6">
              <div class="grid-content">
                <el-form-item label="单位名称" class="detail-form-item" prop="name">
                  <el-input size="medium" v-model="entity.companyName"></el-input>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="grid-content">
                <el-form-item label="单位地址" class="detail-form-item">
                  <el-input size="medium" v-model="entity.address"></el-input>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content">
                <el-form-item label="注册时间" class="detail-form-item">
                  <el-input size="medium" v-model="entity.registerTime"></el-input>
                </el-form-item>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6">
              <div class="grid-content">
                <el-form-item label="用户头像" class="detail-form-item">
                  <img :src="entity.headImg" />
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content">
                <el-form-item label="是否大客户" class="detail-form-item">
                  <el-input size="medium" :value="entity.large?'是':'否'" readonly></el-input>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content">
                <el-form-item label="大客户折扣" class="detail-form-item">
                  <el-input size="medium" v-model="entity.discount" readonly></el-input>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content">
                <el-form-item label="登录过期时间" class="detail-form-item">                  
                  <el-date-picker v-model="entity.expireTime" type="datetime"  value-format="YYYY-MM-DD HH:mm:ss" placeholder="选择日期时间">
                  </el-date-picker>
                </el-form-item>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6">
              <div class="grid-content">
                <el-form-item label="创建人" class="detail-form-item">
                  <el-input size="medium" v-model="entity.creator" disabled></el-input>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content">
                <el-form-item label="创建时间" class="detail-form-item">
                  <el-input size="medium" v-model="entity.createTime" disabled></el-input>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content">
                <el-form-item label="修改人" class="detail-form-item">
                  <el-input size="medium" v-model="entity.modifier" disabled></el-input>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content">
                <el-form-item label="修改时间" class="detail-form-item">
                  <el-input size="medium" v-model="entity.modifyTime" disabled></el-input>
                </el-form-item>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="24">
              <div class="grid-content">
                <el-form-item label="备注" class="detail-form-item">
                  <el-input type="textarea" v-model="entity.remark"></el-input>
                </el-form-item>
              </div>
            </el-col>
          </el-row>
        </el-form>
      </el-scrollbar>
    </div>
    <el-divider class="detail-divider"></el-divider>
    <div class="detail-form-item-btns">
      <el-button v-if="edit" size="medium" class="detail-form-item-btn" type="primary" @click="save">保存</el-button>
      <el-button size="medium" class="detail-form-item-btn" @click="goBack">返回列表</el-button>
      <el-button size="medium" class="detail-form-item-btn" @click="reset">刷新</el-button>
    </div>
  </div>

  <el-dialog v-model="dialogVisible" title="设置大客户折扣" width="30%">
    <div>
      <el-form :model="entity" ref="formDiscount" :rules="discountRules" labelPosition="right" label-width="120px">
        <el-form-item label="用户昵称">
          <el-input class="form-text-input" v-model="entity.realName" readonly></el-input>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input class="form-text-input" v-model="entity.phone" readonly></el-input>
        </el-form-item>
        <el-form-item label="是否大客户" prop="large">
          <el-radio-group v-model="entity.large">
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="大客户折扣" prop="discount">
          <el-input class="form-text-input" placeholder="请输入折扣，例如0.9,表示9折" v-model="entity.discount"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="changeLargeDiscount">确 定</el-button>
      </span>
    </template>
  </el-dialog>

</template>

<script lang="ts">
import { Options } from "vue-class-component";
import { BaseDetail } from "@/script/core/view/BaseDetail";
import { AppUser } from "@/script/apps/user/entity/UserEntity";
import { ServiceContext, ServiceFactory } from "@/script/core/base/ServiceData";
import { DictUtil } from "@/script/core/Dict";
import { AppUserService } from "@/script/apps/user/service/AppUserService";
import { ElMessage, ElNotification } from "element-plus";
import { UserService } from "@/script/apps/system/service/UserService";

@Options({})
export default class AppUserDetail extends BaseDetail {
  private service = new AppUserService();

  private dialogVisible = false;

  private discountRules = {
    large: [{ required: true, message: "请选择是否大客户", trigger: "change" }],
    discount: [
      { required: true, message: "请输入大客户折扣", trigger: "blur" },
    ],
  };

  public initData(): ServiceContext {
    return ServiceFactory.build(
      "biz_user",
      "/user/appuser",
      "/user/appuser",
      this.service
    );
  }

  public newEntity() {
    const entity: AppUser = {};
    return entity;
  }

  openLargeDiscount() {
    this.dialogVisible = true;
  }

  changeLargeDiscount() {
    const self = this;
    const user: AppUser = this.entity;
    (this.$refs.formDiscount as any).validate((valid: boolean) => {
      if (valid) {
        self.service.setLargeDiscount(
          user,
          function (result: any) {
            ElNotification({
              type: "success",
              title: "设置大客户折",
              message: "设置大客户折扣成功",
            });
            self.dialogVisible = false;
          },
          function (error: Error) {
            ElMessage.error("设置大客户折扣失败，原因：" + error.message);
          }
        );
      } else {
        return false;
      }
    });
  }
}
</script>

<style lang="scss">
</style>
